import {CompanyState} from './states/company.state';

export const companyStates = [
    CompanyState
];
